import React from 'react';

import FormContainerContent, { FormContainerContentProps } from './FormContainerContent';
import FormContainerFooter, { FormContainerFooterProps } from './FormContainerFooter';
import FormContainerHeader, { FormContainerHeaderProps } from './FormContainerHeader';

import './FormContainer.scss';

interface FormContainerProps extends React.HTMLAttributes<HTMLElement> {
    /** Pass \<FormContainer.Header />, \<FormContainer.Content />, \<FormContainer.Footer /> as children. */
    children: React.ReactNode;
}

interface FormContainerComponent {
    /** Header of the form. Takes a title, and optional description */
    Header: React.FC<FormContainerHeaderProps>;
    /** Footer of the form. Takes optional hide flag */
    Footer: React.FC<FormContainerFooterProps>;
    /** Content of the form. */
    Content: React.FC<FormContainerContentProps>;
}

const FormContainer: React.FC<FormContainerProps> & FormContainerComponent = ({
    children,
    ...rest
}): React.JSX.Element => (
    <section {...rest} className={`kortbetjening-form-main-container${rest.className ? ` ${rest.className}` : ''}`}>
        {children}
    </section>
);

FormContainer.Header = FormContainerHeader;
FormContainer.Content = FormContainerContent;
FormContainer.Footer = FormContainerFooter;

export default FormContainer;
